import { defineStore } from "pinia";

import apiClient from "@/lib/apiClient";

const items = JSON.parse(localStorage.getItem("items"));
const initialState = items
  ? {
      status: { loaded: true },
      ingredients: items.ingredients,
      baseRecipes: items.baseRecipes,
      recipes: items.recipes,
    }
  : { status: {}, ingredients: [], recipes: [], baseRecipes: [] };

export const useItemStore = defineStore("item", {
  state: () => initialState,

  actions: {
    update(items) {
      localStorage.setItem("items", JSON.stringify(items));
      this.ingredients = items.ingredients;
      this.recipes = items.recipes;
      this.baseRecipes = items.baseRecipes;
    },

    ingredientLookup(ingredient, field) {
      const targetList = ingredient.baseRecipe
        ? this.recipes
        : this.ingredients;
      if (targetList.length) {
        const ing = targetList.find(
          (item) => item._id === ingredient.reference
        );
        if (ing) return ing[field];
      }
    },

    computePartialCost(ingredient) {
      if (ingredient.baseRecipe)
        return (
          ingredient.quantity *
          this.computeRecipeCost(ingredient.reference, true)
        );
      else
        return (
          ingredient.quantity *
          (this.ingredientLookup(ingredient, "unitPrice") /
            this.ingredientLookup(ingredient, "servingQuantity"))
        );
    },

    computeRecipeCost(id, unitCost = false) {
      const recipe = this.recipes.find((item) => item._id === id);
      let recipeCost = 0;
      if (recipe.ingredients) {
        for (let i = 0; i < recipe.ingredients.length; i++)
          recipeCost += this.computePartialCost(recipe.ingredients[i]);
      }
      return unitCost ? recipeCost / recipe.servingQuantity : recipeCost;
    },

    getBaseRecipes(recipes) {
      if (!recipes || !Array.isArray(recipes)) {
        return [];
      }
      const baseRecipes = recipes.filter((item) => item.baseRecipe);
      return baseRecipes;
    },

    async load() {
      try {
        const res = await apiClient.getAllItems();
        // Check if the response is valid and contains the expected data
        if (res && res.status === "success" && res.data) {
          this.update({
            ingredients: res.data.ingredients || [],
            recipes: res.data.recipes || [],
            baseRecipes: this.getBaseRecipes(res.data.recipes),
          });
        } else {
          // Handle error response or invalid data
          this.update({
            ingredients: [],
            recipes: [],
            baseRecipes: [],
          });
        }
      } catch (error) {
        // Handle any errors from the API call
        console.error("Failed to load items:", error);
        this.update({
          ingredients: [],
          recipes: [],
          baseRecipes: [],
        });
      }
    },
  },
});
